var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1596 135L1596 163",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1596.5,
    cy: 130.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1591.99 130.19C1591.99 126.283 1595.29 123.117 1599.36 123.117C1599.94 123.117 1600.51 123.184 1601.06 123.308C1599.74 122.48 1598.19 122 1596.52 122C1591.81 122 1588 125.806 1588 130.5C1588 135.194 1591.81 139 1596.52 139C1598.81 139 1600.89 138.093 1602.43 136.62C1601.49 137.032 1600.45 137.263 1599.36 137.263C1595.29 137.263 1591.99 134.096 1591.99 130.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1605.4 129.6L1605.37 127.146L1603.54 128.719L1601.3 128.056L1602.11 130.337L1600.77 132.381L1603.1 132.218L1604.5 134.144L1605.13 131.763L1607.34 130.909L1605.4 129.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch2);
export default __webpack_public_path__ + "static/media/church_2.bc9442598aaf3dbf6dd226d6266087de.svg";
export { ForwardRef as ReactComponent };